import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface MemberInterviewRecordState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allMemberInterviewRecord: [] | null | any;
}

const initialState: MemberInterviewRecordState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allMemberInterviewRecord: null,
};

export const memberInterviewRecordSlice = createSlice({
  name: 'MemberInterviewRecord',
  initialState,
  reducers: {
    setAllMemberInterviewRecord: (state, action) => {
      state.allMemberInterviewRecord = action.payload.data;
    },
    setMemberInterviewRecord: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllMemberInterviewRecordBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: () => initialState,
  },
});

export const {
  setAllMemberInterviewRecord,
  setMemberInterviewRecord,
  setAllMemberInterviewRecordBySearch,
  reset,
} = memberInterviewRecordSlice.actions;

// Selectors
export const allMemberInterviewRecordDetails = (state: RootState) =>
  state.memberInterviewRecord.allMemberInterviewRecord;

export const getMemberInterviewRecordDetails = (state: RootState) =>
  state.memberInterviewRecord.data;

export const getMemberInterviewRecordTotalRecords = (state: RootState) =>
  state.memberInterviewRecord.totalRecords;

export const getAllMemberInterviewRecordBySearch = (state: RootState) =>
  state.memberInterviewRecord.data;

export default memberInterviewRecordSlice.reducer;
